export enum NotificationFilter {
    Unread = 'unread',
    Read = 'read',
    All = 'all',
}
